import LiveDot from "@/components/LiveDot";
import { useLang } from "@/lib/i18n";

/** «تابعونا» / «Follow us» — the label of the social-icons group. Same black pill, red pulsing dot and
 *  slow teal beam as the live «عاجل» badge. Not a link: following happens via the platform icons. */
export default function FollowBadge({ className = "", testId = "follow-badge" }) {
    const { t } = useLang();
    return (
        <span className={`beam-ring beam-ring--slow beam-ring--badge rounded-[5px] follow-badge-ring ${className}`}>
            <span className="live-badge follow-badge" data-testid={testId} role="heading" aria-level="2">
                <LiveDot tone="red" testId={`${testId}-dot`} />
                <span>{t("followBadge")}</span>
            </span>
        </span>
    );
}
